module.exports = __webpack_public_path__ + "static/media/music.0e1f6ddf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/music.svg
// module id = 569
// module chunks = 0